import { css } from '@emotion/react';

import { Spacing, Typography } from 'chatie-design-system';

import { BadgeProps } from '@components/common/Badge';
import { LinkItem } from '@components/common/ListItem';

import { StoryTheme } from '@constants';
import { IStoryAd, IStoryDetail } from '@model';
import { media } from '@styles/css';
import { useAnalytics } from '@utils/analytics';

import { RRStoryCard } from './Story';

const rrCSS = css`
  padding: ${Spacing.xsmall}px ${Spacing.medium}px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  ${media.tablet} {
    grid-template-columns: repeat(4, 1fr);
    padding: ${Spacing.xsmall}px ${Spacing.xlarge}px;
  }
  ${media.desktop} {
    grid-template-columns: repeat(5, 1fr);
    padding: ${Spacing.xsmall}px ${Spacing.xxlarge}px;
  }

  .card {
    width: calc(100%);
    aspect-ratio: 1;

    .badge-container {
      position: absolute;
      width: 60px;
      height: 20px;
      text-align: center;
      left: -16px;
      ${Typography.body11};
    }
  }
`;

type RRViewListPorps = {
  isShowAd: boolean;
  ad?: IStoryAd;
  badgePreset: Pick<BadgeProps, 'color' | 'backgroundColor' | 'border'>;
  curation: IStoryDetail[];
  onClickMore: () => void;
};

const RRViewList = ({
  isShowAd,
  ad,
  badgePreset,
  curation,
  onClickMore,
}: RRViewListPorps) => {
  const { firebase } = useAnalytics();
  const lastIdx = curation.length - 1;

  return (
    <div css={rrCSS}>
      {isShowAd && !!ad?.story && (
        <LinkItem
          newTab
          hideArrow
          to={`/stories/${ad.story.id}`}
          onClick={() => {
            firebase.logEvent('story_ad_click', {
              storyId: ad.story.id,
              storyAdId: ad.id,
              where: 'curation',
            });
          }}
          left={
            <div className="card">
              <RRStoryCard
                {...ad?.story}
                overlay={false}
                isAd={true}
                badgePreset={badgePreset}
              />
            </div>
          }
        />
      )}
      {curation?.map((item, index) => {
        return (
          <LinkItem
            key={item.id + index.toString()}
            newTab
            hideArrow
            to={
              index === lastIdx
                ? undefined
                : item.theme === StoryTheme.iknow
                ? `/stories/${item.id}/licensed`
                : `/stories/${item.id}`
            }
            onClick={index === lastIdx ? onClickMore : undefined}
            left={
              <div className="card">
                <RRStoryCard
                  {...item}
                  rank={index + 1}
                  overlay={index === lastIdx}
                  width={`calc(33.333% - 16px)`}
                />
              </div>
            }
          />
        );
      })}
    </div>
  );
};

export default RRViewList;
